function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#cc0001",
  d: "M0 0h640v480H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "my_svg__a",
  fill: "#fff",
  d: "M0 445.8h640V480H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "translate(0 -68.6)",
  xlinkHref: "#my_svg__a"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "translate(0 -137.2)",
  xlinkHref: "#my_svg__a"
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "translate(0 -205.8)",
  xlinkHref: "#my_svg__a"
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "translate(0 -274.3)",
  xlinkHref: "#my_svg__a"
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "translate(0 -343)",
  xlinkHref: "#my_svg__a"
});

var _ref8 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "translate(0 -411.5)",
  xlinkHref: "#my_svg__a"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#010066",
  d: "M0 0h372.6v274.3H0z"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fill: "#fc0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M149.7 48.5c-49 0-88.9 39.7-88.9 88.6a88.8 88.8 0 0089 88.6 88.7 88.7 0 0048-14 78.9 78.9 0 01-25.8 4.2 78.7 78.7 0 01-78.8-78.5 78.7 78.7 0 01106.2-73.7 88.7 88.7 0 00-49.7-15.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.1 183.2l-37.4-19.5 11 40-25-33.5-7.8 40.7-7.7-40.7-25.1 33.4 11.2-40-37.6 19.5 28-31.3-42.5 1.6 39-16.3-39-16.5 42.5 1.7L178.9 91l37.4 19.5-11-40 25 33.5 7.8-40.7 7.7 40.7 25.1-33.3-11.2 39.9 37.6-19.4-28 31.2 42.5-1.6-39 16.4 39 16.5-42.5-1.8z"
}));

var SvgMy = function SvgMy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default SvgMy;